// extracted by mini-css-extract-plugin
export default {"circle":"styles_circle__4p6WX","center":"styles_center__-Fi1P","header":"styles_header__tY+I-"};